// extracted by mini-css-extract-plugin
export default {"infoRow":"vgRJqHWKyP8qomIGIvcc"};